import { render } from "./DeploymentName.vue?vue&type=template&id=10ae9e2f"
import script from "./DeploymentName.vue?vue&type=script&lang=js"
export * from "./DeploymentName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__